import type { JobIssueSeverity } from '@/entities/media-campaign';

/**
 * One tone per severity, shared by the issue list and the node drawer.
 *
 * Advice is muted rather than amber: a note about what a platform does on its own is
 * not a thing to check, and colouring it like one taught reviewers to ignore amber.
 */
export const SEVERITY_TONE: Record<JobIssueSeverity, string> = {
  error: 'text-destructive',
  warning: 'text-warning-foreground',
  advice: 'text-muted-foreground',
};
